

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GStepCard',
  computed: {},
  methods: {},
})
export default class GStepCard extends Vue {
  @Prop({ default: false }) completed: boolean;
  mounted() {}
}
